import React, { useEffect, useState } from "react";
import "./AccountEdit.css";
import { cityListApi, updateMyAccountApi } from "../services/apiService";
import { useUserContext } from "../context/UserContext";
import { toast } from "react-toastify";
import ExclamationIcon from "../assets/images/exclamation.svg";
import { updateUserInLocalStorage } from "../utils/userLocalStorage";
import { useCities } from "@/queries/useLocalisationQuery"

const AccountEdit = props => {
  const { userData, setUserData } = useUserContext();
  const [isEditing, setIsEditing] = useState(false);
  const [firstName, setFirstName] = useState(props?.allDetails?.first_name);
  const [lastName, setLastName] = useState(props?.allDetails?.last_name);
  const [email, setEmail] = useState(props?.allDetails?.email);
  const [city, setCity] = useState(props?.allDetails?.city_id);
  const [birthCity, setBirthCity] = useState(props?.allDetails?.birth_city_id);
  const [idNumber, setIdNumber] = useState(props?.allDetails?.id_number);
  const [gender, setGender] = useState(props?.allDetails?.gender);
  const [patientAddress, setPatientAddress] = useState(props?.allDetails?.patient_address);
  const [dob, setDob] = useState("26 June, 1987");
  const [editBtnDis, setEditBtnDis] = useState(false);

  const [formErrorsSignup, setFormErrorsSignup] = useState({
    first_name: "",
    last_name: "",
    city_id: "",
    birth_city_id: "",
    email: "",
    cell_phone: "",
    month: "",
    day: "",
    year: "",
    id_number: "",
    gender: "",
    patient_address: "",
  });

  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedDay, setSelectedDay] = useState();
  const [selectedYear, setSelectedYear] = useState();

  // Function to get month name from month index
  const getMonthName = index => months[index];

  // Function to get month index from month name
  const getMonthIndex = name => months.indexOf(name);

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const years = Array.from({ length: 101 }, (_, i) => 1920 + i);

  const { 
    data: cityList
   } = useCities()

  const validateFormSignup = () => {
    let isValid = true;
    const errors = {
      first_name: "",
      last_name: "",
      city_id: "",
      birth_city_id: "",
      email: "",
      month: "",
      day: "",
      year: "",
      id_number: "",
      gender: "",
      patient_address: "",
    };

    if (!firstName) {
      errors.first_name = "Please enter your first name";
      isValid = false;
      // } else if (!nameRegex.test(firstName)) {
      //   errors.first_name = "First name can only contain letters and spaces";
      //   isValid = false;
    } else if (/[\u0600-\u06FF]/.test(firstName)) {
      // Arabic characters range in Unicode: \u0600-\u06FF
      errors.first_name = "First name cannot contain Arabic characters.";
      isValid = false;
    }

    if (!lastName) {
      errors.last_name = "Please enter your last name";
      isValid = false;
      // } else if (!nameRegex.test(lastName)) {
      //   errors.last_name = "Last name can only contain letters and spaces";
      //   isValid = false;
    } else if (/[\u0600-\u06FF]/.test(lastName)) {
      // Arabic characters range in Unicode: \u0600-\u06FF
      errors.last_name = "Last name cannot contain Arabic characters.";
      isValid = false;
    }

    // if (!city) {
    //   errors.city_id = "Please select city";
    //   isValid = false;
    // }

    if (!birthCity) {
      errors.birth_city_id = "Please select birth city";
      isValid = false;
    }

    if (email && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/.test(email)) {
      errors.email = "Email address is invalid.";
      isValid = false;
    }

    if (!selectedMonth) {
      errors.month = "Please select month";
      isValid = false;
    }

    if (!selectedDay) {
      errors.day = "Please select day";
      isValid = false;
    }

    if (!selectedYear) {
      errors.year = "Please select year";
      isValid = false;
    }

    if (!idNumber) {
      errors.id_number = "Please enter id number.";
      isValid = false;
    }

    if (idNumber && !/^\d{9}$/.test(idNumber)) {
      errors.id_number = "Invalid Id Number. It must be exactly 9 digits.";
      isValid = false;
    }

    if (!gender) {
      errors.gender = "Please select gender.";
      isValid = false;
    }

    // if (!patientAddress === "") {
    //   errors.patient_address = "Please enter address.";
    //   isValid = false;
    // }

    setFormErrorsSignup(errors);
    return isValid;
  };

  const handleEditClick = async () => {
    // if (!isEditing) {
    //   setIsEditing(true);
    // }
    if (validateFormSignup()) {
      // console.log(selectedMonth);
      // console.log(months.findIndex(item => item === selectedMonth));

      // return;
      setEditBtnDis(true);
      try {
        let formData = new FormData();
        formData.append("first_name", firstName);
        formData.append("last_name", lastName);
        formData.append("month", months.findIndex(item => item === selectedMonth) + 1);
        formData.append("day", selectedDay);
        formData.append("year", selectedYear);
        formData.append("city_id", city || "");
        formData.append("birth_city_id", birthCity);
        formData.append("id_number", idNumber);
        formData.append("gender", gender);
        formData.append("email", email);
        formData.append("patient_address", patientAddress || "");

        let response = await updateMyAccountApi(formData);
        if (response) {
          if (response.data.res === true) {
            setIsEditing(!isEditing);
            updateUserInLocalStorage({
              "users.first_name": response.data.data.first_name,
              "users.last_name": response.data.data.last_name
            }, setUserData);
            toast.success(response.data.msg, { autoClose: 1500 });
          } else {
            toast.error(response.data.msg, { autoClose: 1500 });
          }
        }
        setEditBtnDis(false);
      } catch (error) {
        setEditBtnDis(false);
        toast.error("Something went wrong in server. Please try again.", { autoClose: 1500 });
      }
      if (isEditing) {
        setDob(`${selectedDay} ${selectedMonth}, ${selectedYear}`);
      }
    }
  };

  useEffect(() => {
    // Update state when props.allDetails changes
    if (props.allDetails) {
      getCityList();
      setFirstName(props.allDetails.first_name || "");
      setLastName(props.allDetails.last_name || "");
      setEmail(props.allDetails.email || "");
      setCity(props.allDetails.city_id || "");
      setBirthCity(props.allDetails.birth_city_id || "");
      setIdNumber(props.allDetails.id_number || "");
      setGender(props.allDetails.gender || "");
      setPatientAddress(props.allDetails.patient_address || "");
      if (props.allDetails?.dob) {
        const date = new Date(props.allDetails?.dob);
        const monthIndex = date.getMonth();
        const day = date.getDate();
        const year = date.getFullYear();
        setDob(day + " " + getMonthName(monthIndex) + "," + " " + year);
        setSelectedMonth(getMonthName(monthIndex));
        setSelectedDay(day);
        setSelectedYear(year);
      }
    }
  }, [props.allDetails]);

  return (
    <div className="AccountInfomainDiv">
      <div className="hdnDiv accountHdn2">
        <h2>Personal Information</h2>
        {isEditing ? (
          <>
            <button
              className="cancelBtn"
              onClick={() => {
                setIsEditing(false);
                setFormErrorsSignup({
                  irst_name: "",
                  last_name: "",
                  city_id: "",
                  birth_city_id: "",
                  email: "",
                  cell_phone: "",
                  month: "",
                  day: "",
                  year: "",
                  id_number: "",
                  gender: "",
                  patient_address: "",
                });
              }}>
              Cancel
            </button>
            <button onClick={() => handleEditClick()} disabled={editBtnDis}>
              {editBtnDis ? "Please wait..." : "Save"}
            </button>
          </>
        ) : (
          <button onClick={() => setIsEditing(true)}>Edit</button>
        )}
      </div>

      <ul className={`accountDetails ${isEditing ? "editing" : ""}`}>
        <li>
          <label>First name</label>
          <input
            type="text"
            value={firstName}
            className={`${formErrorsSignup.first_name ? "inputHaveError" : ""}`}
            onChange={e => setFirstName(e.target.value)}
            disabled={!isEditing}
            placeholder="First name (in French letters)"
          />

          {formErrorsSignup.first_name && (
            <span className="vaidationError">
              <img className="exclamationIcon" src={ExclamationIcon} />
              {formErrorsSignup.first_name}
            </span>
          )}
        </li>
        <li>
          <label>Last name</label>
          <input
            className={`${formErrorsSignup.last_name ? "inputHaveError" : ""}`}
            type="text"
            value={lastName}
            onChange={e => setLastName(e.target.value)}
            disabled={!isEditing}
            placeholder="Last name (in French letters)"
          />
          {formErrorsSignup.last_name && (
            <span className="vaidationError">
              <img className="exclamationIcon" src={ExclamationIcon} />
              {formErrorsSignup.last_name}
            </span>
          )}
        </li>

        <li>
          <label>Gender</label>
          <select
            className={`select-style1 ${formErrorsSignup.gender ? "inputHaveError" : ""}`}
            value={gender}
            onChange={e => setGender(e.target.value)}
            disabled={!isEditing}>
            <option value="" disabled selected>
              Select Gender
            </option>
            <option value={"male"}>Male</option>
            <option value={"female"}>Female</option>
            {/* <option value={"other"}>Other</option> */}
          </select>
          {formErrorsSignup.gender && (
            <span className="vaidationError">
              <img className="exclamationIcon" src={ExclamationIcon} />
              {formErrorsSignup.gender}
            </span>
          )}
          {/* <input type="text" value={city} onChange={e => setCity(e.target.value)} disabled={!isEditing} /> */}
        </li>

        {/* <li>
          <label>City</label>
          <select
            className={`select-style1 ${formErrorsSignup.city_id ? "inputHaveError" : ""}`}
            value={city}
            onChange={e => setCity(e.target.value)}
            disabled={!isEditing}>
            {cityList?.map((item, index) => (
              <option key={index} value={item?.id}>
                {item?.name}
              </option>
            ))}
          </select>
          {formErrorsSignup.city_id && (
            <span className="vaidationError">
              <img className="exclamationIcon" src={ExclamationIcon} />
              {formErrorsSignup.city_id}
            </span>
          )}
        </li> */}

        <li>
          <label>Birth City</label>
          <select
            className={`select-style1 ${formErrorsSignup.birth_city_id ? "inputHaveError" : ""}`}
            value={birthCity}
            onChange={e => {
              setBirthCity(e.target.value);
              setFormErrorsSignup(prev => ({ ...prev, birth_city_id: "" }));
            }}
            disabled={!isEditing}>
            {cityList?.map((item, index) => (
              <option key={index} value={item?.id}>
                {item?.name}
              </option>
            ))}
          </select>
          {formErrorsSignup.birth_city_id && (
            <span className="vaidationError">
              <img className="exclamationIcon" src={ExclamationIcon} />
              {formErrorsSignup.birth_city_id}
            </span>
          )}
          {/* <input type="text" value={city} onChange={e => setCity(e.target.value)} disabled={!isEditing} /> */}
        </li>

        <li>
          <label>Username</label>
          <input
            type="text"
            value={props?.allDetails?.username}
            disabled={!isEditing}
            readOnly
          />
        </li>

        <li>
          <label>Email address</label>
          <input
            className={`${formErrorsSignup.email ? "inputHaveError" : ""}`}
            type="text"
            value={email}
            onChange={e => setEmail(e.target.value)}
            disabled={!isEditing}
          // readOnly
          />
          {formErrorsSignup.email && (
            <span className="vaidationError">
              <img className="exclamationIcon" src={ExclamationIcon} />
              {formErrorsSignup.email}
            </span>
          )}
        </li>

        {/* <li>
          <label>Address</label>
          <input
            className={`${formErrorsSignup.patient_address ? "inputHaveError" : ""}`}
            type="text"
            value={patientAddress}
            onChange={e => setPatientAddress(e.target.value)}
            disabled={!isEditing}
          />
          {formErrorsSignup.patient_address && (
            <span className="vaidationError">
              <img className="exclamationIcon" src={ExclamationIcon} />
              {formErrorsSignup.patient_address}
            </span>
          )}
        </li> */}

        <li>
          <label>Id Number</label>
          <input
            className={`${formErrorsSignup.id_number ? "inputHaveError" : ""}`}
            type="number"
            value={idNumber}
            onChange={e => setIdNumber(e.target.value)}
            disabled={!isEditing}
          />
          {formErrorsSignup.id_number && (
            <span className="vaidationError">
              <img className="exclamationIcon" src={ExclamationIcon} />
              {formErrorsSignup.id_number}
            </span>
          )}
        </li>

        <li>
          <label>Date of birth</label>
          {isEditing ? (
            <div>
              <select value={selectedDay} onChange={e => setSelectedDay(e.target.value)} className="select-style1">
                {days.map(day => (
                  <option key={day} value={day}>
                    {day}
                  </option>
                ))}
              </select>
              <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} className="select-style2">
                {months.map(month => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                ))}
              </select>

              <select value={selectedYear} onChange={e => setSelectedYear(e.target.value)} className="select-style1">
                {years.map(year => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <input type="text" value={dob} disabled={!isEditing} />
          )}
        </li>
      </ul>
    </div>
  );
};

export default AccountEdit;
